export const PARKING_SPACE_CREATE_VEHICLE = 'PARKING_SPACE_CREATE_VEHICLE';
export const VEHICLE_TYPE_CREATE_VEHICLE = 'VEHICLE_TYPE_CREATE_VEHICLE';
export const AUTHORIZED_TO_DRIVE_CREATE_ASSOCIATE = 'AUTHORIZED_TO_DRIVE_CREATE_ASSOCIATE';
export const COUNSELING_SEVERITY_CREATE_COUNSELING = 'COUNSELING_SEVERITY_CREATE_COUNSELING';
export const INCIDENT_TYPE_CREATE_INCIDENT = 'INCIDENT_TYPE_CREATE_INCIDENT';
export const ISSUE_TYPE_CREATE_ISSUE = 'ISSUE_TYPE_CREATE_ISSUE';
export const KUDO_TYPE_CREATE_KUDO = 'KUDO_TYPE_CREATE_KUDO';
export const COMPANY_CREATE_VEHICLE = "COMPANY_CREATE_VEHICLE"
export const ASSOCIATE_ROSTER_STATUS_CREATE_ROUTE = 'ASSOCIATE_ROSTER_STATUS_CREATE_ROUTE';
export const PHOTO_LOG_TYPE_CREATE_VEHICLE_PHOTO_LOG = 'PHOTO_LOG_TYPE_CREATE_VEHICLE_PHOTO_LOG';
export const ROUTE_START_TIME_CREATE_ROUTE = 'ROUTE_START_TIME_CREATE_ROUTE';